import type { Except } from "type-fest";
import { z } from "zod";
import type { ManifestFieldType } from "./manifest-field-type";

type ManifestFieldValue = {
    readonly _type: "MANIFEST_FIELD_VALUE";
    readonly index: number;
    readonly data: Record<ManifestFieldType, string>;
    readonly checkedIn: boolean;
};

const manifestFieldValueZodSchema: z.ZodSchema<ManifestFieldValue> = z.object({
    _type: z.literal("MANIFEST_FIELD_VALUE"),
    index: z.number(),
    data: z.record(z.string(), z.string()), // quickfix zod issue,
    checkedIn: z.boolean(),
});

type CreateManifestItemValueParams = Except<ManifestFieldValue, "_type">;
const createManifestFieldValue = (
    params: CreateManifestItemValueParams,
): ManifestFieldValue => {
    return {
        ...params,
        _type: "MANIFEST_FIELD_VALUE",
    };
};

const isManifestFieldValue = (
    item:
        | {
              _type: unknown;
          }
        | undefined,
): item is ManifestFieldValue => {
    if (typeof item === "undefined") return false;
    return item._type === "MANIFEST_FIELD_VALUE";
};

export {
    createManifestFieldValue,
    isManifestFieldValue,
    manifestFieldValueZodSchema,
};
export type { ManifestFieldValue as ManifestFieldValue };
